<div class="remark-dialog-container">
  <textarea
    [(ngModel)]="textareaValue"
    [required]="data.required"
    rows="5"
    [placeholder]="data.heading + (data.prefix ? data.prefix : ' Reason')"
  >
  </textarea>
  <div class="action-buttons">
    <button (click)="back()">Close</button>
    <button (click)="submit()" [disabled]="data.required && !textareaValue">
      Submit
    </button>
  </div>
</div>
